import React, { useState, useEffect } from 'react';
import './ResultadosIndividuales.css';
import jsPDF from 'jspdf';
import io from 'socket.io-client';
import { useNavigate } from 'react-router-dom';
import { socket } from '../socket';

const ResultadosIndividuales = () => {

    const navigate = useNavigate();
    const [aparato, setAparato] = useState('');
    const [nivel, setNivel] = useState('');
    const [categoria, setCategoria] = useState('');
    const [niveles, setNiveles] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [results, setResults] = useState([]);

    function updateScreens() {
        
        if (results.length > 0 && aparato && nivel && categoria) {
            const data = {
                results: results,
                aparato: aparato,
                nivel: nivel,
                categoria: categoria
            };
            if (aparato === 'Piso') {
                socket.emit('piso-result', data);
            } else if (aparato === 'Viga') {
                socket.emit('viga-result', data);
            } else if (aparato === 'Barra') {
                socket.emit('barra-result', data);
            } else if (aparato === 'Salto') {
                socket.emit('salto-result', data);
            } else if (aparato === 'allaround') {
                socket.emit('allaround-result', data);
            }
        }
    };

    const fetchNiveles = async () => {
        try {
            const response = await fetch(`https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/obtener_niveles`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                });
            if (!response.ok) {
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            setNiveles(data.niveles);
        } catch (error) {
            console.error('Error obteniendo niveles', error);
        }
    };

    const fetchCategorias = async () => {
        try {
            const response = await fetch(`https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/obtener_categorias?nivel=${nivel}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                });
            if (!response.ok) {
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            setCategorias(data.categorias);
        } catch (error) {
            console.error('Error obteniendo niveles', error);
        }
    };

    // call API when the button is clicked if aparato, nivel and categoria not empty
    const fetchResults = async () => {
        if (!nivel || !aparato || !categoria) {
            return;
        }
        try {
            const response = await fetch(`https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/resultadosIndividuales?aparato=${aparato}&nivel=${nivel}&categoria=${categoria}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                });


            if (!response.ok) {
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            const results = data.result;
            // results.sort((a, b) => parseFloat(b.puntaje) - parseFloat(a.puntaje));
            // sort based on puntaje, if same score then based on allaround score
            results.sort((a, b) => {
                const puntajeDiff = parseFloat(b.puntaje) - parseFloat(a.puntaje);
                if (puntajeDiff !== 0) {
                    return puntajeDiff; // sort by main score
                } else {
                    return parseFloat(b.allaround) - parseFloat(a.allaround); // tie-breaker
                }
            });
            
            setResults(results);

        } catch (error) {
            console.error('Error obteniendo results', error);
        }
    };  

    const descargarPDF = async () => {
        try {
          const response = await fetch('https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/descargarPuntaje', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              aparato,
              nivel,
              categoria,
              results
            }),
          });
      
          if (!response.ok) {
            throw new Error(`Request failed with status: ${response.status}`);
          }
      
        } catch (error) {
          console.error('Error obtaining results:', error);
        }
      };

    useEffect(() => {
        fetchNiveles();
    }, []);

    useEffect(() => {
        if (nivel) {   
            fetchCategorias();
        }
    }, [nivel]);

    return (
        <div className='container'>

            {/* seleccionar aparato, nivel, categoría para buscar en la base de datos*/}
            <div className='row-select'>
            
                <div className='fila-select'>
                    <label for="nombre">
                        Aparato:
                    </label>
                    <select id="aparato" value={aparato} onChange={(e) => setAparato(e.target.value)}>
                        <option value="">--</option>
                        <option value="Salto">Salto</option>
                        <option value="Barra">Barra</option>
                        <option value="Viga">Viga</option>
                        <option value="Piso">Piso</option>
                        <option value="allaround">All Around</option>
                    </select>
                </div>

                <div className='fila-select'>
                    <label for="nombre">
                        Nivel:
                    </label>
                    <select id="nombre" value={nivel} onChange={(e) => setNivel(e.target.value)}>
                        <option value="">--</option>
                        {niveles.map((name) => (
                            <option key={name} value={name}>
                                {name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className='fila-select'>
                    <label for="nombre">
                        Categoría:
                    </label>
                    <select id="nombre" value={categoria} onChange={(e) => setCategoria(e.target.value)}>
                        <option value="">--</option>
                        {categorias && categorias.map((name) => (
                            <option key={name} value={name}>
                                {name}
                            </option>
                        ))}
                    </select>
                </div>

                <button className='boton-calcular' onClick={fetchResults} type="submit">
                    Calcular
                </button>

            </div>

            {/* display  score */}
            {results.length > 0 && (
            <div className='results'>
                <div>
                    <h2>Resultados {aparato} {nivel} Categoría {categoria}</h2>
                    {results.map((result, index, array) => {
                        let currentIndex = index + 1;
                            
                        if (index > 0 && result.puntaje === array[index - 1].puntaje && result.allaround === array[index-1].allaround) {
                            currentIndex = array[index - 1].index;
                        } else if (index === 0) {
                            currentIndex = 1;
                        } else {
                            currentIndex = array[index - 1].index + 1;
                        }

                        array[index].index = currentIndex;
                        result.currentIndex = currentIndex;

                        return (
                            <div className='gimnasta-puntaje' key={index}>
                                <p>
                                    <strong>{array[index].index}. {result.nombre} {result.apellido}</strong>
                                </p>
                                <p>Puntaje: {result.puntaje}</p>
                                <p>Club: {result.club}</p>
                            </div>
                        );
                    })}
                </div>
                <button className='descargar-button' onClick={descargarPDF}>Descargar PDF</button> 
                <button className='descargar-button' onClick={updateScreens}>Refrescar pantalla</button>
            </div>
        )}



        </div>
    );
};

export default ResultadosIndividuales;
